import React from "react";
import Dialog from "@mui/material/Dialog";
import Typography from "@mui/material/Typography";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimesCircle } from "@fortawesome/free-solid-svg-icons";

const Details = ({ popUpOpen, togglePopUp, details }) => {
  const handleCancel = () => {
    togglePopUp();
  };
  return (
    <Dialog
      open={popUpOpen}
      onClose={togglePopUp}
      maxWidth="xl"
      PaperProps={{
        className: "myDialogPopUp",
      }}
    >
      <div className="myDrawer">
        <div className="inventory_popup_title">
          <Link to={false} style={{ position: "absolute", right: 8, top: 8, color: "#dd5151", fontSize : '2rem' }} onClick={handleCancel}>
            <FontAwesomeIcon icon={faTimesCircle} />
          </Link>
        </div>
        <h5 style={{textAlign : 'center'}}>Details</h5>
        <Typography
          variant="body1"
          component="div"
          className="my_delete_popup_paragraph"
          style={{textAlign : 'left'}}
        >
          <h5>
            {typeof details === "string" ? (
              details
            ) : Array.isArray(details) || (typeof details === "object" && details !== null) ? (
              <pre>{JSON.stringify(details, null, 2)}</pre>
            ) : (
              "No details available"
            )}
          </h5>
        </Typography>
      </div>
    </Dialog>
  );
};

export default Details;
